import React from 'react';
import { Dayjs } from 'dayjs';
import { Appointment } from '../../services/appointmentApi';
import { TimelineGrid } from './TimelineGrid';
import './TimelineView.css';

interface Employee {
  id: number;
  first_name: string;
  last_name: string;
  role: string;
}

interface TechnicianSchedule {
  id: number;
  user_id: number;
  day_of_week: number;
  start_time: string;
  end_time: string;
  is_active: boolean;
}

interface ScheduleException {
  id: number;
  user_id: number;
  exception_type: 'time_off' | 'break' | 'special_hours' | 'holiday';
  start_datetime: string;
  end_datetime: string;
  reason?: string;
}

interface TimelineViewProps {
  date: Dayjs;
  appointments: Appointment[];
  employees: Employee[];
  schedules: Map<number, TechnicianSchedule[]>;
  exceptions: ScheduleException[];
  onAppointmentClick: (appointment: Appointment) => void;
  onRefresh: () => void;
}

export const TimelineView: React.FC<TimelineViewProps> = ({
  date,
  appointments,
  employees,
  schedules,
  exceptions,
  onAppointmentClick,
  onRefresh
}) => {
  if (employees.length === 0) {
    return (
      <div className="timeline-view-empty">
        <p>No employees available. Please add technicians or owners to schedule appointments.</p>
      </div>
    );
  }

  return (
    <div className="timeline-view">
      <TimelineGrid
        date={date}
        appointments={appointments}
        employees={employees}
        schedules={schedules}
        exceptions={exceptions}
        onAppointmentClick={onAppointmentClick}
        onRefresh={onRefresh}
      />
    </div>
  );
};
